import { SectionHeading } from "@/components/primitives";
import { Reveal } from "@/components/motion";
import PricingCards, { CurrencySwitcher } from "@/components/PricingCards";

export default function PricingPreview() {
  return (
    <section id="pricing" className="relative border-t border-border py-24 sm:py-32" data-testid="pricing-preview-section">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="flex flex-col items-start justify-between gap-8 lg:flex-row lg:items-end">
          <SectionHeading
            eyebrow="Pricing"
            title="Priced for outcomes, not features."
            subtitle="One AI-powered workspace to run and grow your business. Early adopters get special launch pricing."
          />
          <Reveal delay={0.1}>
            <CurrencySwitcher />
          </Reveal>
        </div>

        <div className="mt-14 sm:mt-16">
          <PricingCards />
        </div>
      </div>
    </section>
  );
}
